import Authenticate from '../Authenticate';
import CopilotChannelListener from './CopilotChannelListener';
import { jsx as _jsx } from "react/jsx-runtime";
const SetupCopilotChannelListener = () => {
  // We skip redirects here in Authenticate because we don't actually want to
  // render the route (otherwise we'd load a bunch of useless JS on apps that
  // can't use copilot), we just want to avoid loading the channel listeners.
  return /*#__PURE__*/_jsx(Authenticate, {
    skipRedirect: true,
    children: /*#__PURE__*/_jsx(CopilotChannelListener, {})
  });
};
export default SetupCopilotChannelListener;